export default () => {
  const backButtons = document.getElementsByClassName('is-back-button');
  for (let i = 0; i < backButtons.length; i += 1) {
    backButtons[i].addEventListener('click', (evt) => {
      evt.preventDefault();
      console.debug('going javascript back');
      window.history.back();
      return false;
    });
  }
};
